export default "__VITE_ASSET__PICOQdsQ__"